import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import usedeletedata from '../../Hooks/useDeleteData';
import {
  Add_Stages,
  Delete_Stages,
  Get_All_Stages,
  Get_Error,
  Get_One_Stage_to_get_type,
  Get_One_Stages,
  Update_One_Stages,
} from '../Types';

export const Add_Stage_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/stage`, body);

    dispatch({
      type: Add_Stages,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get no stage action
export const Get_No_Stage_Name = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stage?stageisactivate=true&name=No Stage`);

    dispatch({
      type: Get_All_Stages,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all stage data
export const GetAll_stage_Data = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stage?stageisactivate=true`);

    dispatch({
      type: Get_All_Stages,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all stage data
export const GetAll_stage_Data_not_active = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stage?stageisactivate=false`);

    dispatch({
      type: Get_All_Stages,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one stage data
export const GetOne_stage_Data = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stage/${id}`);

    dispatch({
      type: Get_One_Stages,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one stage data
export const GetOne_stagetogettype_Data = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/stage/${id}`);

    dispatch({
      type: Get_One_Stage_to_get_type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one stage data
export const UpdateOne_stage_Data = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/stage/${id}`, body);

    dispatch({
      type: Update_One_Stages,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one stage data
export const DeleteOne_stage_Data = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/stage/${id}`);

    dispatch({
      type: Delete_Stages,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
